import { get, post, put, del } from '../../services/api';

// Catégories & Titres
export const fetchCategories = async () => {
  const res = await get('/categories');
  return res.data;
};

export const fetchTitres = async () => {
  const res = await get('/titres');
  return res.data;
};

export const fetchTitresByCategorie = async (categorieId) => {
  const res = await get('/titres', { params: { categorie: categorieId } });
  return res.data;
};

// Produits (détail + par vendeur)
export const fetchProduitById = async (id) => {
  const res = await get(`/produits/${id}`);
  return res.data;
};

export const fetchProduitsByVendeur = async (vendeurId) => {
  const res = await get(`/produits/vendeur/${vendeurId}`);
  return res.data;
};

// CRUD Produits (avec upload)
export const ajouterProduit = async (formData) => {
  const res = await post('/produits', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
};

export const modifierProduit = async (id, formData) => {
  const res = await put(`/produits/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
};

export const supprimerProduit = async (id, vendeurId) => {
  const res = await del(`/produits/${id}`, {
    data: { vendeur_id: vendeurId }, // axios delete + body via config.data
    headers: { 'Content-Type': 'application/json' },
  });
  return res.data;
};
